import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';

import './index.scss';

/**
 * A panel with header[optional] and footer[optional]
 */
const Panel = ({id, border = true, header, content, footer, className, sellClassNames = ''}) => {
  return (
    <div id={id} className={`Panel ${border ? 'Panel-Border' : ''} ${className ? className : ''}`}>
      {header ? <div className={cs('Panel__Header', sellClassNames)}>{header}</div> : null}
      {content}
      {footer ? <div className="Panel__Footer">{footer}</div> : null}
    </div>
  );
};

Panel.propTypes = {
  border: PropTypes.bool,
  id: PropTypes.string,
  header: PropTypes.element,
  footer: PropTypes.element,
  className: PropTypes.string,
};

export default Panel;
